<!--
  The designed empty state, extracted from Devices.vue:32-39 (refresh_plan.md
  3.1.6 names that markup as already the best empty state in the codebase).
  Kept free of table assumptions on purpose: LwTable composes this component
  rather than owning its own copy of it.
-->
<template>
  <div class="lw-c-empty">
    <div v-if="$slots.illustration" class="lw-c-empty__illustration">
      <slot name="illustration" />
    </div>
    <component :is="headingTag" class="lw-c-empty__title">
      {{ title }}
    </component>
    <p class="lw-c-empty__body">
      {{ body }}
    </p>
    <div v-if="$slots.action" class="lw-c-empty__action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
const MIN_HEADING_LEVEL = 2;
const MAX_HEADING_LEVEL = 4;

export default {
  name: 'LwEmpty',
  props: {
    title: {
      type: String,
      required: true,
    },
    // Required, no default: "so nobody ships a blank" is the plan's
    // phrasing for the invitation copy, which only works if a caller cannot
    // skip writing it.
    body: {
      type: String,
      required: true,
    },
    // An empty state living inside a panel is not the page's <h1>, so the
    // level is the caller's call, bounded to real heading levels below the
    // page title.
    headingLevel: {
      type: Number,
      default: 3,
      validator: value => value >= MIN_HEADING_LEVEL && value <= MAX_HEADING_LEVEL,
    },
  },
  computed: {
    headingTag() {
      return `h${this.headingLevel}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/mixins.generated';

.lw-c-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--lw-space-2);
  // Generous space, per the contract: an empty state has to feel designed,
  // not like a missing row.
  padding: var(--lw-space-12) var(--lw-space-6);
  // No border of its own: the container (panel, table, page) owns the edge.
}

.lw-c-empty__illustration {
  margin-bottom: var(--lw-space-2);
}

.lw-c-empty__title {
  margin: 0;
  font: var(--lw-type-heading);
  color: var(--lw-fg-primary);
}

.lw-c-empty__body {
  margin: 0;
  max-width: 40ch;
  font: var(--lw-type-body-sm);
  color: var(--lw-fg-secondary);
}

.lw-c-empty__action {
  margin-top: var(--lw-space-2);
}
</style>
